module.exports = __webpack_public_path__ + "img/register-two.822baab2.png";